import { useQuery } from 'react-query';

import { printApi } from 'Print/service/print.api';
import { Print } from 'Print/model/Print';

export const printKey = 'print';
export const usePrintQuery = (userId: string) =>
  useQuery<Print[]>([printKey, userId], () => printApi.getList(userId));
